<template>
    <div>
        <template v-for="attr in extattrs">
            <ext-attr-item
                v-if="!hideAttrsIds.includes(attr.attrId)"
                :key="attr.attrId"
                :attr="attr"
                :recommend-attr-list="recommendAttrList"
                :mode="mode"
                :empty-text="emptyText"
                :input-type-is-textarea="inputTypeIsTextarea"
                :can-clear="canClear"
                :lock-fields="lockFields"
                :default-disabled="defaultDisabled"
                :unique-flag="uniqueFlag"
                :ignore-valid="ignoreValid"
                :showValueImage="showValueImage"
                :focused-marking-list="focusedMarkingList"
                @changeExtAttr="changeExtAttr"
            />
        </template>
    </div>
</template>

<script>
import extAttrItem from 'components/extAttrItem';

export default {
    componentName: 'extAttr',
    components: {
        extAttrItem,
    },
    props: {
        extattrs: {
            // 当前模块的扩展属性
            type: Array,
        },
        mode: {
            type: String,
            required: true,
        },
        inputTypeIsTextarea: {
            type: Boolean,
            deafault: false,
        },
        emptyText: {
            type: String,
            default: '',
        },
        canClear: {
            type: Boolean,
            default: true,
        },
        lockFields: {
            type: Array,
            default: () => ([]),
        },
        hideAttrsIds: {
            type: Array,
            default: () => ([]),
        },
        // 是否忽略无效option
        ignoreValid: {
            type: Boolean,
            default: false,
        },
        defaultDisabled: {
            type: Boolean,
            default: false,
        },
        uniqueFlag: {
            type: [String, Number],
            default: '',
        },
        // 是否显示拓展属性选中值的说明
        showValueImage: {
            type: Boolean,
            default: false,
        },
        // 推荐的扩展属性值
        recommendAttrList: {
            type: Array,
            default: () => ([]),
        },
        // c端展示重点属性
        focusedMarkingList: {
            type: Array,
            default: () => ([]),
        },
    },
    methods: {
        changeExtAttr(ea) {
            // 格式化当选的值
            this.$emit('skuExtAttrChange', ea);
        },
    },
};
</script>
